import { createAction } from "@reduxjs/toolkit";

import {
  deleteScheduledPostActionTypes,
  getPortionScheduledActionTypes,
  getScheduledPostsActionTypes,
  scheduledPostUploadedActionType,
  updateScheduledPostActionType,
  editScheduledPostActionTypes,
  setScheduledPostsActionTypes,
  addPendingEditingScheduledPostActionType,
  removePendingEditingScheduledPostActionType,
} from "./actionTypes";

export const getScheduledPosts = createAction(
  getScheduledPostsActionTypes.request,
  (payload) => ({ payload }),
);

export const getScheduledPostsSuccess = createAction(
  getScheduledPostsActionTypes.success,
  (payload) => ({ payload }),
);

export const getScheduledPostsFailure = createAction(
  getScheduledPostsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getPortionScheduled = createAction(
  getPortionScheduledActionTypes.request,
);

export const getPortionScheduledSuccess = createAction(
  getPortionScheduledActionTypes.success,
  (payload) => ({ payload }),
);

export const getPortionScheduledFailure = createAction(
  getPortionScheduledActionTypes.failure,
  (payload) => ({ payload }),
);

export const addPendingEditingScheduledPost = createAction(
  addPendingEditingScheduledPostActionType,
  (payload) => ({ payload }),
);

export const removePendingEditingScheduledPost = createAction(
  removePendingEditingScheduledPostActionType,
  (payload) => ({ payload }),
);

export const updateScheduledPost = createAction(
  updateScheduledPostActionType,
  (payload) => ({
    payload,
  }),
);

export const scheduledPostUploaded = createAction(
  scheduledPostUploadedActionType,
  (payload) => ({
    payload,
  }),
);

export const deleteScheduledPost = createAction(
  deleteScheduledPostActionTypes.request,
  (payload) => ({ payload }),
);

export const deleteScheduledPostSuccess = createAction(
  deleteScheduledPostActionTypes.success,
  (payload) => ({ payload }),
);

export const deleteScheduledPostFailure = createAction(
  deleteScheduledPostActionTypes.failure,
  (payload) => ({ payload }),
);

export const setScheduledPosts = createAction(
  setScheduledPostsActionTypes.success,
  (payload) => ({ payload }),
);

export const editScheduledPost = createAction(
  editScheduledPostActionTypes.request,
);
export const editScheduledPostSuccess = createAction(
  editScheduledPostActionTypes.success,
);
export const editScheduledPostFailure = createAction(
  editScheduledPostActionTypes.failure,
);
export const editScheduledPostReset = createAction(
  editScheduledPostActionTypes.reset,
);
